// extracted by mini-css-extract-plugin
export var closeButton = "_pc-2";
export var closeButtonIcon = "_pc-3";
export var lightboxContent = "_pc-1";
export var lightboxOverlay = "_pc-0";